import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class SettingService {
  static settingCreate = async (
    name,
    address,
    phone,
    nic,
    role,
    email,
    password
  ) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/admin/create",
        data: {
          name: name,
          address: address,
          phone: phone,
          nic: nic,
          role: role,
          email: email,
          password: password,
        },
        headers: {
          "Content-Type": "application/json",
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static settingDetails = async (rowsPerPage, page) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/settings/search",
        data: {
          keyword: "",
          status: "",
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let settingDetail = response.data.data.results;
      return settingDetail;
    } catch (err) {
      throw err;
    }
  };

  static settingDetailsID = async (settingID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/settings/" + settingID,
        data: {
          filter: [],
          limit: 10,
          skip: 0,
          sort: "DESC",
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let settingDetailID = response.data.data;

      return settingDetailID;
    } catch (err) {
      throw err;
    }
  };

  static settingDelete = async (settingID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/settings/delete/" + settingID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static settingUpdate = async (settingID, value) => {

    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/settings/update/" + settingID,
        data: {
          value: value,
        },

        headers: {
          "Content-Type": "application/json",
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };
}
